// Kunngjøringer fra Brønnøysund (skrapet + cachet av workeren). Selvstendig datafil —
// real-API mot /selskapsinfo/:orgnr/kunngjoringer, mock via env.useMocks. Samme mønster
// som selskapsinfoApi.ts + hooks.ts. Caches i workeren → høy staleTime her.
import { useQuery } from "@tanstack/react-query";

import { apiClient } from "@/lib/apiClient";
import { env } from "@/lib/env";

export interface Kunngjoring {
  id: string;
  type: string | null;
  dato: string | null;
  tekst: string | null;
  lenke: string | null;
}

export interface KunngjoringerResponse {
  kunngjoringer: Kunngjoring[];
  cached: boolean;
  available: boolean;
  status: string;
}

async function realKunngjoringer(orgnr: string): Promise<KunngjoringerResponse> {
  const r = await apiClient.get<{ ok: true } & KunngjoringerResponse>(
    `/selskapsinfo/${orgnr}/kunngjoringer`
  );
  return {
    kunngjoringer: r.kunngjoringer,
    cached: r.cached,
    available: r.available,
    status: r.status,
  };
}

async function mockKunngjoringer(_orgnr: string): Promise<KunngjoringerResponse> {
  return {
    available: true,
    cached: true,
    status: "ok",
    kunngjoringer: [
      {
        id: "1",
        type: "Konkursåpning",
        dato: "2025-02-27",
        tekst: "Konkurs åpnet i selskapets bo ved kjennelse fra tingretten.",
        lenke: "https://w2.brreg.no/kunngjoring/hent_en.jsp?kid=1",
      },
      {
        id: "2",
        type: "Innkalling til skiftesamling",
        dato: "2025-03-14",
        tekst: "Innkalling til skiftesamling i konkursboet.",
        lenke: "https://w2.brreg.no/kunngjoring/hent_en.jsp?kid=2",
      },
      {
        id: "3",
        type: "Tvangsavvikling/forfall",
        dato: "2024-11-05",
        tekst: "Varsel om tvangsoppløsning på grunn av manglende innsendt regnskap.",
        lenke: "https://w2.brreg.no/kunngjoring/hent_en.jsp?kid=3",
      },
    ],
  };
}

export function useKunngjoringer(orgnr: string) {
  return useQuery({
    queryKey: ["selskapsinfo", "kunngjoringer", orgnr],
    enabled: !!orgnr,
    staleTime: 60 * 60 * 1000, // skrapes/cachet av workeren — hent sjelden
    queryFn: () => (env.useMocks ? mockKunngjoringer(orgnr) : realKunngjoringer(orgnr)),
  });
}
